export default "__VITE_ASSET__840ff218__"